<template>
  <div class="wrapper-full lift">
    <table class="table" name="颚托">
      <tbody>
        <tr>
          <span style="font-size: 30px">{{ $t("langcfg.txtBracket") }}:</span>
        </tr>
        <tr>
          <td :style="`width: ${isCompact ? (isIT ? '5%' : '20%') : '100%'}`">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="bracketUp"
              @mouseup.native="stopBracket"
              @touchstart.native="bracketUp"
              @touchend.native="stopBracket"
            >
              <i class="iconfont icon-upward_filled"></i>
            </el-button>
          </td>
          <td v-if="isCompact" style="width: 20%">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="bracketDown"
              @mouseup.native="stopBracket"
              @touchstart.native="bracketDown"
              @touchend.native="stopBracket"
            >
              <i class="iconfont icon-downward_filled"></i>
            </el-button>
          </td>
        </tr>
        <split-h class="split-h" :splitH="10"></split-h>
        <tr v-if="!isCompact">
          <td style="width: 100%">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="bracketDown"
              @mouseup.native="stopBracket"
              @touchstart.native="bracketDown"
              @touchend.native="stopBracket"
            >
              <i class="iconfont icon-downward_filled"></i>
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table" name="机身">
      <tbody>
        <td>
          <span style="font-size: 30px">{{ $t("langcfg.txtMachine") }}:</span>
        </td>
        <tr>
          <td :style="`width: ${isCompact ? '50%' : '100%'}`">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="machineUp"
              @mouseup.native="stopMachine"
              @touchstart.native="machineUp"
              @touchend.native="stopMachine"
            >
              <i class="iconfont icon-upward_filled"></i>
            </el-button>
          </td>
          <td v-if="isCompact" style="width: 100%">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="machineDown"
              @mouseup.native="stopMachine"
              @touchstart.native="machineDown"
              @touchend.native="stopMachine"
            >
              <i class="iconfont icon-downward_filled"></i>
            </el-button>
          </td>
        </tr>
        <split-h class="split-h" :splitH="10"></split-h>
        <tr v-if="!isCompact">
          <td style="width: 100%">
            <el-button
              class="btn-oprator border-normal"
              @mousedown.native="machineDown"
              @mouseup.native="stopMachine"
              @touchstart.native="machineDown"
              @touchend.native="stopMachine"
            >
              <i class="iconfont icon-downward_filled"></i>
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { isDefined, isFunction } from "../../shared/utils";
export default {
  name: "LiftControl",

  data() {
    return {
      isIT: false
    };
  },
  props: {
    // 空间排列是否紧凑
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.isIT = window.settings.language === "it";
  },
  updated() {
    this.isIT = window.settings.language === "it";
  },
  methods: {
    bracketUp() {
      global.LiftDevice.upBracket();
    },
    bracketDown() {
      global.LiftDevice.downBracket();
    },
    machineUp() {
      global.LiftDevice.upMachine();
    },
    machineDown() {
      global.LiftDevice.downMachine();
    },
    blurBtn(e) {
      if (isDefined(e)) {
        if (isDefined(e.currentTarget) && isFunction(e.currentTarget.blur)) {
          e.currentTarget.blur();
        } else if (isDefined(e.target) && isFunction(e.target.blur)) {
          e.target.blur();
        }
      }
    },
    stopBracket(e) {
      this.blurBtn(e);
      global.LiftDevice.stopBracket();
    },
    stopMachine(e) {
      this.blurBtn(e);
      global.LiftDevice.stopMachine();
    }
  }
};
</script>
<style lang="less" scoped>
.el-button {
  width: 90%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: 85px;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
.btn-oprator {
  height: @header-fs+50px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.lift {
  font-size: @header-fs;
  height: 100%;
  color: white;
  .btn-oprator:hover {
    .label {
      color: @btn-hover-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/LiftControl.vue